
export const environment = {
  production: true,
  // apiUrlBase: 'https://cicerone.cms-iurban.com',
  // urlWebSocket: 'wss://gpt.cms-iurban.com/ws/assistant',
  // urlWebSocketTools: 'wss://gpt.cms-iurban.com/ws/assistant/tool-feedback',
  // urlChatHistory: 'https://gpt.cms-iurban.com/v2/get_conversation',
  // urlTextToSpeech: 'https://gpt.cms-iurban.com/tts/stream'
  apiUrlBase: 'https://fitur2026b.ciceroneweb.com',
  urlWebSocket: 'wss://pre.gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://pre.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://pre.gpt.cms-iurban.com/get_conversation',
  urlTextToSpeech: 'https://pre.gpt.cms-iurban.com/tts/stream'
};
